import { useState } from 'react';

export const useShowCustomPlayButton = (videoRef: any) => {
  const [shouldNativeControlsBeVisible, setAreNativeControlsVisible] =
    useState(false);
  const onPlayButtonPressed = () => {
    setAreNativeControlsVisible((prev) => !prev);
    if (videoRef.current) {
      videoRef.current.playAsync();
    }
  };
  const onVideoFinishedPlaying = () => {
    setAreNativeControlsVisible(false);
  };
  return {
    shouldNativeControlsBeVisible,
    onPlayButtonPressed,
    onVideoFinishedPlaying,
    showPlayButton: !shouldNativeControlsBeVisible,
  };
};
